module.exports = __webpack_public_path__ + "static/media/transiluminator-caution.3b5e95c1.svg";